/**
 * Privacy Policy Constants
 * Website details and contact information
 */

export const PRIVACY_POLICY_CONFIG = {
  WEBPLATFORM_NAME: "onvisit.pro",
  WEBSITE_URL: "onvisit.pro",
  CONTACTS_URL: "https://onvisit.pro/contacts",
  EMAIL: "support@onvisit.pro",
  PHONE: "+38 (099) 109-02-89",
  PHONE_LINK: "tel:0991090289",
  // Data Controller Information
  CONTROLLER_NAME: "Visit SaaS Platform",
  CONTROLLER_TYPE: "Юридична особа", // Legal entity
  CONTROLLER_LOCATION: "Україна", // Ukraine, Kyiv
  CONTROLLER_REGISTRATION: "Зареєстровано згідно законодавства України",
  CONTROLLER_REPRESENTATIVE: "Представник: Команда розробки onvisit.pro",
} as const;
